export var CalendarEventType;
(function (CalendarEventType) {
    CalendarEventType["Visit"] = "Visit";
})(CalendarEventType || (CalendarEventType = {}));
export const DEFAULT_CALENDAR_EVENT_TYPE = CalendarEventType.Visit;
export const DEFAULT_CALENDAR_EVENT_DURATION_MINUTES = 60;
export const CALENDAR_EVENT_TIME_GRANULARITY_MINUTES = 5;
//# sourceMappingURL=calendar-event.js.map